import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { GL_ASSIGNMENT_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  data: FieldValues
}

const mutateGLAssignmentsPlan = async ({ data, communityId }: mutateProps) => {
  return await axiosAuth.post(
    `${GL_ASSIGNMENT_API(communityId)}/bulk/plan`,
    data
  );
};

const useGLAssignmentsPlanMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateGLAssignmentsPlan,
    ...queryParams,
  });

export default useGLAssignmentsPlanMutation;
